import {ApolloClient} from 'apollo-client'
import {createHttpLink} from 'apollo-link-http'
import {InMemoryCache, IntrospectionFragmentMatcher} from 'apollo-cache-inmemory'
import {ApolloLink} from 'apollo-link'
import {onError} from 'apollo-link-error'
import store from '../store';
import router from '../router/router';
import config from '../../static/config.json'

// let Token = store.getters.getToken || localStorage.getItem("access_token");

const httpLink = createHttpLink({
  uri: `${config.https.api}/graphql`,
  credentials: 'include'
})
// let Token2 = 'eyJhbGciOiJSUzI1NiIsImtpZCI6Ijg2NTU1MzFBMjA3NDgwMDZCMDZCRjI1MjcwMEMxMTlEIiwidHlwIjoiYXQrand0In0.eyJuYmYiOjE2MDEzNDQwMjQsImV4cCI6MTYwMTM1MTIyNCwiaXNzIjoiaHR0cHM6Ly9hdXRoLnpoYW5zaGFuZ3hpdS5jb20iLCJhdWQiOiJzaG93b25saW5lLWFwaSIsImNsaWVudF9pZCI6InN5bmFpci1zaG93b25saW5lLWpzIiwic3ViIjoiNjg1OTgzNDctMjUzNS00ZDVjLTlmZDgtNjlmNzFjZDFjZWVhIiwiYXV0aF90aW1lIjoxNjAxMzQ0MDE5LCJpZHAiOiJXZWl4aW5XYXAiLCJzaWQiOiI2N0IxQ0MzQjJGNEVFMzQwM0Y2ODE4N0YxMjhEQTFDRSIsImlhdCI6MTYwMTM0NDAyNCwic2NvcGUiOlsib3BlbmlkIiwic2hvd29ubGluZS1hcGkiLCJwcm9maWxlIl0sImFtciI6WyJleHRlcm5hbCJdfQ.ZmC5ps5qWl2LgwyzIo2mLAxP7Zy9LmV2Ug5OUn3fGkCW9ip8_quh1C4bt8_R7EHM6B_CXi2LPDJDLw1JbSxXLpinQEVbR8IOO0ES4ek46s8AdpYQRrSttoOI3wchBN7MhH9S173-ZhNRgC_VZLYxoeT77qE0ildbem6LHBQo9Q2j43WAQWTHbpIkvZ0OatuozzwEmf0kvyc6nEkz1tl6kmZ7-4zPpGPy9hLGvtRt8UhuihSUBKzQJdineiPC-l81NK2r3MIqs3tlPNZFp9CgVGjeDsVWTtCNlVVklg93GvhelFKupfE_48kX5qiVkxqGkWFYhGvyZZYy7VIHlHjAXQ';
const middlewareLink = new ApolloLink((operation, forward) => {
    let Token = store.getters.getToken || localStorage.getItem("access_token");
    if(Token){
      operation.setContext({
          headers: {
            Authorization:"Bearer " + Token,
            "lang-version":"en"
          }
      })
    }else{
      operation.setContext({
        headers: {
          "lang-version":"en"
        }
    })
    }
  
    return forward(operation).map(response => { // 响应返回的结果
        return response
    })
})

// 拦截器：统一错误处理
const errorLink = onError(({ networkError , response}) => {
  console.error(networkError, response,'errorMsg------------');
    let errorMsg = ''
    if (!!response && response.errors !== undefined && response.errors.length) {
      errorMsg = !response.errors[0].message ? '服务器错误' : response.errors[0].message
      for (let err of response.errors) {
        switch (err.extensions.code) {
          case 'authorization':
            console.log('没有权限'); 
            let ua = navigator.userAgent.toLowerCase();
            let is_wx=false;
            // console.log(ua,'usususuusaususauuaauuasuauauauua')
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
              is_wx= true;
            }
            store.commit('setUserInfo','');
            store.commit('userRole','');
            store.commit('setToken',''); 
            if(is_wx){
              sessionStorage.setItem("login", "false"); // 清除登录状态
              router.push({
                path: '/auth'
              });
            }else{
              sessionStorage.setItem("login", "false"); // 清除登录状态
              localStorage.clear();
              location.reload()
            }
            return;
        }
      }
    }
    if (!!networkError) {
      errorMsg = networkError.message
      if (networkError.result !== undefined) {
        errorMsg = networkError.result.success === false ? networkError.result.message : networkError.result.error
      }
    }
    if (!!errorMsg) {
      console.error(errorMsg,'errorMsg------------');
      // let login = sessionStorage.getItem('login');
      // if(login == 'true') {  // apollo请求报错了，且已经是登录的状态；
        // sessionStorage.setItem("login", "false"); // 清除登录状态
        // router.push({
        //   path: '/auth'
        // });
      // }
    }
})

const authLink = middlewareLink.concat(httpLink)


const apollo = new ApolloClient({
  link: errorLink.concat(authLink),
  cache: new InMemoryCache(),
  // connectToDevTools: true,
  // defaultOptions: defaultOptions
})

export default apollo